import { graphql } from "relay-runtime"

export const deUpdateAllPatientConditionsMutation = graphql`
  mutation deUpdateAllPatientConditionsMutation($input: De_updateAllPatientConditionsInput!) {
    updateAllPatientConditions: de_updateAllPatientConditions(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on IcdCodeNotUnique {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      patientConditionInformationOutput {
        id
        status
        conditions {
          comment
          icdDiagnosis {
            id
            isAssociation
            diagnosisCode
            primaryCode
            secondaryCode
            associationType
            text
          }
        }
      }
    }
  }
`
